import { brandFeatures } from '@/mocks/home';

export default function BrandFeatures() {
  return (
    <section className="py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            为什么选择mogu视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全新的视频购物体验，让你发现时尚、享受购物的乐趣
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {brandFeatures.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
                <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}